import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
export const TagButtonListSkeleton = (props) => {
    const { className = '', count } = props;
    const dummies = useArrayWithIndex(count);
    return (_jsx("ul", Object.assign({ className: clsx('flex items-center flex-wrap gap-[10px]', 'bg-gray-75', 'rounded-[3px]', 'p-20', className) }, { children: dummies.map(({ index }) => (_jsx("li", Object.assign({ className: clsx('inline-flex items-center justify-center', 'h-[39px]', 'p-12', 'rounded-[3px]', 'border border-solid border-gray-100', 'bg-gray-50 hover:bg-gray-75') }, { children: _jsx(Skeleton, { className: 'w-[64px] h-[20px]' }) }), `TagButtonListSkeleton_item_${index}`))) })));
};
